<!--
  学期成绩汇总
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <el-card class="card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont" style="padding-left: 0px">搜索</h3>
      </div>
      <div class="card-body">
        <el-row :gutter="24">
          <el-col :span="8" class="mb-3">
            <div class="selTitleBox">
              <span class="spTitle">学期</span>
            </div>
            <div class="selBodyBox">
              <el-select
                v-model="searcForm.SemesterId"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in searchOptions.semesterList"
                  :key="index"
                  :label="item.Title"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card-footer text-center">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click.native="onSearch()"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh" @click.native="onResetSearch()"
          >重置</el-button
        >
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title">教师工作量统计</h3>
      </div>
      <div
        class="card-body p-0"
        v-if="itemData.tdData != null && itemData.tdData.length > 0"
      >
        <el-table :data="itemData.tdData" stripe>
          <!--class="elTableData"!-->
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="90px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user"
            fixed
            label="姓名"
            class="elColumn"
          ></el-table-column>
          <el-table-column
            prop="total"
            fixed
            label="总计"
            class="elColumn"
            align="center"
          ></el-table-column>
          <el-table-column
            v-for="(item, count) in itemData.thData"
            :label="item"
            :key="count"
            class="elColumn"
            :width="item.length < 4 ? 80 : item.length * 25"
            align="center"
          >
            <template slot-scope="scope">
              <span
                class="color-gray"
                v-if="
                  scope.row.workloads[count] == '' ||
                  scope.row.workloads[count] == null
                "
                >-</span
              >
              <span v-else>{{ scope.row.workloads[count] }}</span>
            </template>
          </el-table-column>
          <comPage :isPage="false" :paging="paging"></comPage>
        </el-table>
      </div>
      <div class="card-body p-0" v-else>
        <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
import '@/assets/css/Admin.css';
import qs from 'qs';
import comPage from '@/components/Page.vue';
export default {
  components: {
    comPage,
  },
  data() {
    return {
      isTeacher: false,
      SearchTitles: [],
      currentYear: null,
      searchOptions: {
        semesterList: [],
      },
      searcForm: {
        SemesterId: null,
      },
      fullscreenLoading: false,
      // 搜索数据集
      SearchList: null,

      itemData: {
        thData: null,
        tdData: null,
      },
      paging: {
        totalCount: 0,
      },

      arrSearch: {
        semesterId: '',
      },
      isPower: {
        //增删改查 权限管理
        admin_workload: false,
      },
    };
  },
  methods: {
    /**
     * @description 重置搜索
     */
    onResetSearch() {
      let that = this;
      that.searcForm.SemesterId = that.currentYear;
      onGetData(that);
    },
    /**
     * @description 搜索
     */
    onSearch() {
      let that = this;
      onGetData(that);
    },
  },
  created() {
    let that = this;
    isPower(that, 'admin_workload', 'admin_workload');

    // 获取用户信息
    let tpUserInfo = onGetNowUser(that);

    that.isTeacher = tpUserInfo.isTeacher;
    ajaxGet(that, '/api/admin/semester', null, function (resSemester) {
      // 学期
      if (!regNullArray(resSemester)) {
        let SemesterId = that.searcForm.SemesterId;
        // 获得学期数据
        for (let item of resSemester) {
          let arrTemp = {
            Title: item.name, //semester[item].name,
            Value: item.semesterId, //semester[item].semesterId,
          };
          // 默认学期显示当前学期
          if (
            SemesterId == null ||
            typeof SemesterId == 'undefined' ||
            SemesterId == ''
          ) {
            if (item.isCurrent == true) {
              that.currentYear = item.semesterId;
              that.searcForm.SemesterId = item.semesterId;
            }
          }
          that.searchOptions.semesterList.push(arrTemp);
        }
        onGetData(that);
      }
    });
  },
  watch: {
    $route() {
      let that = this;
      onGetData(that);
    },
  },
};

///加载列表数据
// 获取数据
function onGetData(that, isInit) {
  that.fullscreenLoading = true;
  let getData = {
    semesterId: that.searcForm.SemesterId,
  };
  ajaxGet(that, `/api/admin/workload/statis`, getData, function (resData) {
    that.itemData.tdData = resData.workloads;
    that.itemData.thData = resData.titles;
    if (resData.workloads.length != null) {
      that.paging.totalCount = resData.workloads.length;
    }
    that.fullscreenLoading = false;
  });
}
</script>

<style scoped="scoped">
.navTabsCont .nav-link {
  font-size: 12px;
}

/*重置样式*/
.table tbody td,
.table thead th {
  font-size: 0.875rem;
  /*14*/
}

.table tr td,
.table tr th {
  text-align: center;
}

.table tr th:nth-child(1),
.table tr th:nth-child(2),
.table tr td:nth-child(1),
.table tr td:nth-child(2) {
  text-align: left;
}

.selTitleBox {
  font-size: 14px;
}

.selTitleBox .spTitle {
  padding-bottom: 5px;
  display: block;
  color: #303133;
}
</style>
